<style src="./styles.scss" lang="scss"></style>
<template>
  <div class="wrapper wrapper-content animated fadeIn">
    <header class="type-selector">
      <button
        class="btn btn-outline type-button"
        @click="selectType(type.MOVEMENT)"
        :class="{ 'type-button_active': !isTransferMode }"
      >
        Movimento
      </button>
      <button
        class="btn btn-outline type-button"
        @click="selectType(type.TRANSFER)"
        :class="{ 'type-button_active': isTransferMode }"
      >
        Transferência
      </button>
    </header>
    <form class="content" @submit.prevent="createMovement">
      <div class="row">
        <div class="form-group col-md-8">
          <label>Descrição</label>
          <input
            type="text"
            placeholder="Pagamento da conta de luz"
            class="form-control"
            v-model="form.description"
          />
        </div>

        <div class="form-group col-md-4">
          <label>Conta</label>
          <select class="form-control" v-model="form.account">
            <option
              v-for="(account, index) in formattedAccounts"
              :key="index"
              :value="account._id"
            >
              {{ account.name }}
            </option>
          </select>
        </div>
      </div>
      <div class="row">
        <div class="from-group col-md-4">
          <label>Valor</label>
          <input
            v-model="form.amount"
            type="number"
            class="form-control"
            step="0.01"
            value="0.00"
            placeholder="0.00"
          />
        </div>
        <div class="from-group col-md-4">
          <label>Forma de pagamento</label>
          <select class="form-control" v-model="form.paymentType">
            <option
              v-for="(item, index) in paymentsType"
              :key="index"
              :value="item.value"
            >
              {{ item.label }}
            </option>
          </select>
        </div>
        <div class="form-group col-md-4" v-if="isTransferMode">
          <label>Conta Destino</label>
          <select class="form-control" v-model="form.transferredTo">
            <option
              v-for="(account, index) in destinyAccounts"
              :key="index"
              :value="account._id"
            >
              {{ account.name }}
            </option>
          </select>
        </div>
        <div class="from-group col-md-4" v-else>
          <label>Tipo de movimento</label>
          <select class="form-control" v-model="form.type">
            <option
              v-for="(item, index) in movementsType"
              :key="index"
              :value="item.value"
            >
              {{ item.label }}
            </option>
          </select>
        </div>
      </div>
      <br />
      <div class="row">
        <div class="form-group col-md-6">
          <label>Label</label>
          <tags-input
            v-model="form.labels"
            placeholder="Insira uma label"
            :existing-tags="existentLabels"
            :typeahead="true"
            only-existing-tags
          ></tags-input>
        </div>
        <div class="form-group col-md-2">
          <label>Vencimento</label>
          <input v-model="form.expiration" type="date" class="form-control" />
        </div>
        <div class="form-group col-md-2">
          <label>Data do pagamento</label>
          <input v-model="form.paymentDate" type="date" class="form-control" />
        </div>
        <div class="form-group col-md-2" v-if="setPayPermission">
          <label>Pago?</label>

          <switches
            class="checkbox-content"
            v-model="form.paid"
            theme="bootstrap"
            color="success"
            :emit-on-mount="false"
          ></switches>
        </div>
      </div>
      <div class="row">
        <div class="from-group col-md-4">
          <label>Credor</label>
          <select class="form-control" v-model="form.creditor">
            <option :value="undefined">Sem Credor</option>
            <option
              v-for="(item, index) in creditors"
              :key="index"
              :value="item._id"
            >
              {{ getCreditorName(item) }}
            </option>
          </select>
        </div>
        <div class="from-group col-md-4" v-if="isEmployeeAccount">
          <label>Tipo de movimento(Monitor)</label>
          <select class="form-control" v-model="form.employeeMovementType">
            <option
              v-for="(item, index) in formattedEmployeeMovementsType"
              :key="index"
              :value="item.value"
            >
              {{ item.label }}
            </option>
          </select>
        </div>
      </div>
      <br />
      <div class="form-group">
        <label>Comprovantes e Anexos</label>
        <vue-dropzone
          ref="imgDropZone"
          class="customdropzone"
          id="customdropzone"
          @vdropzone-max-files-exceeded="maxfilesexceeded"
          :options="dropzoneOptions"
          :duplicateCheck="true"
        ></vue-dropzone>
      </div>
      <div class="form-group files-container">
        <div v-for="(file, index) in form.files" :key="index">
          <span class="filename" @click="openFile(file)"
            >{{ file | formatFileName }}
          </span>
          <i class="fa fa-trash text-danger" @click="removeFile(file)"></i>
        </div>
      </div>
      <br />
      <div>
        <button
          class="btn btn-block btn-primary compose-mail"
          href="mail_compose.html"
          v-if="!isEdition"
        >
          <i class="fa fa-save"></i>
          Realizar
          {{
            isTransferMode
              ? 'Trasferencia'
              : movementsType[form.type.toUpperCase()].label
          }}
        </button>
        <button
          type="button"
          @click="updateMovement"
          class="btn btn-block btn-primary compose-mail"
          href="mail_compose.html"
          v-else
        >
          <i class="fa fa-save"></i>
          Salvar dados
        </button>
      </div>
      <br />
      <button
        type="button"
        @click="goBack"
        class="btn btn-block btn-primary compose-mail pull-left"
        href="mail_compose.html"
      >
        Voltar
      </button>
    </form>
  </div>
</template>
<script>
import Switches from 'vue-switches';
import { addHours, format } from 'date-fns';
import vue2Dropzone from 'vue2-dropzone';
// import 'vue2-dropzone/dist/vue2Dropzone.min.css';
import { URI } from '@/config/config';

const paymentsType = {
  CASH: {
    label: 'Dinheiro',
    value: 'cash',
  },
  CREDIT: {
    value: 'credit',
    label: 'Crédito',
  },
  DEBIT: {
    value: 'debit',
    label: 'Débito',
  },
};
const Type = {
  TRANSFER: 'transfer',
  MOVEMENT: 'movement',
};
const movementsType = {
  EXPENSE: {
    label: 'Despesa',
    value: 'expense',
  },
  RECEIVE: {
    value: 'receive',
    label: 'Recebimento',
  },
};
const employeeMovementsTypeMovement = {
  WITHDRAW: {
    label: 'Retirada',
    value: 'withdraw',
  },
  DIFFERENCE: {
    label: 'Diferença',
    value: 'difference',
  },
};
const employeeMovementsTypeTransfer = {
  REINFORCEMENT: {
    label: 'Reforço',
    value: 'reinforcement',
  },
};
const PersonType = {
  PHYSICAL: 'physical',
  LEGAL: 'legal',
};
const actualHours = new Date().getHours() + 3;
export default {
  components: {
    Switches,
    vueDropzone: vue2Dropzone,
  },
  data() {
    return {
      defaultAccount: '',
      type: Type,
      selectedType: Type.MOVEMENT,
      paymentsType: paymentsType,
      movementsType: movementsType,
      accounts: [],
      creditors: [],
      existentLabels: [],
      form: {
        type: movementsType.EXPENSE.value,
        employeeMovementType: employeeMovementsTypeMovement.DIFFERENCE.value,
        description: '',
        paymentType: paymentsType.CASH.value,
        amount: '',
        account: '',
        transferredTo: '',
        expiration: format(new Date(), 'yyyy-MM-dd'),
        paymentDate: format(new Date(), 'yyyy-MM-dd'),
        labels: [],
        paid: false,
        creditor: '',
        files: [],
      },
      dropzoneOptions: {
        url: 'https://httpbin.org/post',
        thumbnailWidth: 120,
        // thumbnailHeight: 300,
        addRemoveLinks: true,
        maxFilesize: 1,
        maxFiles: 2,
        acceptedFiles: 'image/*,application/pdf,text/*',
        dictDefaultMessage: "<i class='fa fa-cloud-upload'></i> Upload",
        dictRemoveFile: 'Remover arquivo',
        dictRemoveFileConfirmation: 'Confirmar remover o arquivo?',
      },
    };
  },
  computed: {
    isTransferMode() {
      return this.selectedType === Type.TRANSFER;
    },
    isReceive() {
      return this.form.type === movementsType.RECEIVE.value;
    },
    destinyAccounts() {
      return this.accounts.filter(
        (account) => String(account._id) !== String(this.form.account),
      );
    },
    formattedAccounts() {
      return this.isTransferMode
        ? this.accounts.filter(
            (account) => account.employee.isEmployee === false,
          )
        : this.accounts;
    },
    isEmployeeAccount() {
      const account = this.accounts.find(
        (account) => String(account._id) === String(this.form.account),
      );
      const destinyAccount = this.accounts.find(
        (account) => String(account._id) === String(this.form.transferredTo),
      );
      return (
        (account && account.employee.isEmployee) ||
        (destinyAccount && destinyAccount.employee.isEmployee)
      );
    },
    formattedEmployeeMovementsType() {
      return this.isTransferMode
        ? employeeMovementsTypeTransfer
        : this.isReceive
        ? { DIFFERENCE: employeeMovementsTypeMovement.DIFFERENCE }
        : employeeMovementsTypeMovement;
    },
    isEdition() {
      return this.$route.params.movementId;
    },
    permissionPayReceives() {
      return this.$store.getters['DATA-ACCESS/HasAccess'](
        'pay-receives',
        'UPDATE',
      );
    },
    permissionPayExpense() {
      return this.$store.getters['DATA-ACCESS/HasAccess'](
        'pay-expense',
        'UPDATE',
      );
    },
    permissionPayTransfer() {
      return this.$store.getters['DATA-ACCESS/HasAccess'](
        'pay-transfer',
        'UPDATE',
      );
    },
    setPayPermission() {
      if (this.selectedType === Type.TRANSFER) {
        return this.permissionPayTransfer;
      } else if (this.form.type === movementsType.EXPENSE.value) {
        return this.permissionPayExpense;
      } else {
        return this.permissionPayReceives;
      }
    },
  },
  watch: {
    selectedType(v) {
      this.form.transferredTo = '';
      this.form.account = this.defaultAccount;
      this.form.employeeMovementType =
        v !== Type.TRANSFER
          ? employeeMovementsTypeMovement.DIFFERENCE.value
          : employeeMovementsTypeTransfer.REINFORCEMENT.value;
    },
    'form.type'() {
      this.form.employeeMovementType =
        employeeMovementsTypeMovement.DIFFERENCE.value;
    },
  },
  filters: {
    formatFileName(v) {
      return v.split('/')[2];
    },
  },
  mounted() {
    this.listAccounts();
    this.loadLabels();
    this.getMovement();
    this.loadCreditors();
  },
  methods: {
    goBack() {
      this.$router.go(-1);
    },
    maxfilesexceeded(file) {
      const dropZoneRef = this.$refs.imgDropZone;
      dropZoneRef.removeAllFiles();
      dropZoneRef.addFile(file);
    },
    async getMovement() {
      if (!this.isEdition) {
        return null;
      }
      try {
        const movement = await this.$store.dispatch(
          'FINANCIAL-ACCOUNT/GetMovement',
          this.isEdition,
        );

        const formattedLabels = movement.labels
          ? this.existentLabels.filter(
              (label) =>
                movement.labels.findIndex(
                  (l) => String(l) === String(label.key),
                ) >= 0,
            )
          : [];
        this.type = Type.MOVEMENT;

        this.form.type = movement.type;
        this.form.description = movement.description;
        this.form.paymentType = movement.paymentType;
        this.form.amount = (movement.amount / 100).toFixed(2);
        this.form.account = movement.account._id;
        this.form.expiration = format(
          new Date(movement.expiration),
          'yyyy-MM-dd',
        );

        this.form.paymentDate = movement.paymentDate
          ? format(new Date(movement.paymentDate), 'yyyy-MM-dd')
          : '';
        this.form.labels = formattedLabels;
        this.form.paid = movement.paid;
        this.form.files = movement.filesPath;
      } catch (error) {
        this.$toasted.error('Não foi possível listar os dados do movimento');
      }
    },
    async loadLabels() {
      const labels = await this.$store.dispatch('LABELS/All');
      const formattedLabels = labels.map((label) => {
        return {
          key: label._id,
          value: label.title,
        };
      });
      this.existentLabels = formattedLabels;
    },
    async listAccounts() {
      try {
        const accounts = await this.$store.dispatch(
          'FINANCIAL-ACCOUNT/ListAll',
        );

        this.accounts = accounts;
      } catch (error) {
        this.$toasted.error('Não foi possível listar as contas');
      }
    },
    resetForm() {
      this.form.description = '';
      this.form.paymentType = '';
      this.form.amount = '';
      this.form.account = '';
      this.form.expiration = format(new Date(), 'yyyy-MM-dd');
      this.form.labels = [];
      this.form.paid = false;
    },
    selectType(type) {
      if (this.isEdition) {
        return;
      }
      this.resetForm();
      this.selectedType = type;
    },
    formatLabel() {
      return this.form.labels.map((label) => label.key);
    },
    readFileAsync(file) {
      return new Promise((resolve, reject) => {
        let reader = new FileReader();
        reader.onload = (fileLoadedEvent) => {
          resolve(fileLoadedEvent.target.result);
        };
        reader.onerror = reject;
        reader.readAsDataURL(file);
      });
    },
    async createMovement() {
      try {
        const payload = {
          ...this.form,
          creditor: this.form.creditor || undefined,
          type: this.isTransferMode ? Type.TRANSFER : this.form.type,
          amount: this.form.amount * 100,
          expiration: addHours(new Date(this.form.expiration), actualHours),
          paymentDate: this.form.paymentDate
            ? addHours(new Date(this.form.paymentDate), actualHours)
            : null,
          labels: this.formatLabel(),
        };

        if (!this.isEmployeeAccount) {
          delete payload.employeeMovementType;
        } else if (!this.form.employeeMovementType) {
          this.$toasted.error('Selecione o tipo de movimento do monitor');
          return;
        }

        const dropZoneRef = this.$refs.imgDropZone;
        const file = dropZoneRef.getAcceptedFiles();
        if (file.length > 0) {
          const images = [];
          for (const f of file) {
            const dataURL = await this.readFileAsync(f);
            images.push({
              base64: dataURL,
              fileName: f.name,
            });
          }
          payload.files = images;
        }

        if (!payload.account) {
          this.$toasted.error('A conta é obrigatória');
          return;
        }
        if (this.isTransferMode && !payload.transferredTo) {
          this.$toasted.error('A conta destino é obrigatória');
          return;
        }

        if (!this.isTransferMode) {
          delete payload.transferredTo;
        }
        await this.$store.dispatch('FINANCIAL-ACCOUNT/CreateMovement', payload);

        this.$toasted.success('Movimento criado com sucesso');
        this.resetForm();
      } catch (error) {
        this.$toasted.error('Falha ao criar movimento');
      }
    },
    async updateMovement() {
      try {
        const payload = {
          ...this.form,
          creditor: this.form.creditor || undefined,
          type: this.form.type,
          amount: this.form.amount * 100,
          expiration: addHours(new Date(this.form.expiration), actualHours),
          paymentDate: this.form.paymentDate
            ? addHours(new Date(this.form.paymentDate), actualHours)
            : null,
          labels: this.formatLabel(),
        };
        if (!this.isEmployeeAccount) {
          delete payload.employeeMovementType;
        } else if (!this.form.employeeMovementType) {
          this.$toasted.error('Selecione o tipo de movimento do monitor');
          return;
        }
        delete payload.transferredTo;
        if (!payload.account) {
          this.$toasted.error('A conta é obrigatória');
          return;
        }
        const dropZoneRef = this.$refs.imgDropZone;
        const file = dropZoneRef.getAcceptedFiles();
        if (file.length > 0) {
          const images = [];
          for (const f of file) {
            const dataURL = await this.readFileAsync(f);
            images.push({
              base64: dataURL,
              fileName: f.name,
            });
          }
          payload.files = images;
        }

        await this.$store.dispatch('FINANCIAL-ACCOUNT/UpdateMovement', {
          payload,
          movementId: this.isEdition,
        });

        this.$router.push({
          name: 'AccountMovement',
        });

        this.$toasted.success('Movimento atualizado com sucesso');
      } catch (error) {
        this.$toasted.error('Falha ao atualizar movimento');
      }
    },
    async loadCreditors() {
      try {
        const creditors = await this.$store.dispatch(
          'FINANCIAL-ACCOUNT/ListAllCreditor',
        );
        this.creditors = creditors;
      } catch (error) {
        this.$toasted.error('Falha ao lista credores');
      }
    },
    getCreditorName(creditor) {
      if (creditor.personType === PersonType.PHYSICAL) {
        return creditor.physical.name;
      } else if (creditor.personType === PersonType.LEGAL) {
        return creditor.legal.companyName;
      } else {
        return '';
      }
    },
    openFile(file) {
      const path = `${URI}notify-photos/${file}`;
      window.open(path);
    },
    async removeFile(file) {
      const payload = {
        file,
      };
      try {
        await this.$store.dispatch('FINANCIAL-ACCOUNT/RemoveMovementFile', {
          payload,
          movementId: this.isEdition,
        });
        this.getMovement();
      } catch (error) {
        this.$toasted.error('Falha ao excluir arquivo');
      }
    },
  },
};
</script>\